export default {
  token: "",
  cookieChecked: false,
  user: undefined,
};
//tiDdwgYq2D#Xx9y6 sendgrid conta@tentaculo.digital
// api key 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
// d-83d92e4a4d854f408bb6bf01f5f35b6b
